import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

/**
 * Extra content a host page can place inside the standard contact sidebar without forking it or
 * threading props through every wrapper (ContactOrgDetailPage → ContactDetailPage → …NextJs → Core).
 * RIA Search uses `belowHeader` for the advisor's firm / fit / warm-path context; every other page
 * provides nothing and the sidebar renders exactly as before.
 */
export type ContactDetailSlots = {
  /** Rendered directly under the sidebar header, above the tab content. */
  belowHeader?: ReactNode;
};

const ContactDetailSlotsContext = createContext<ContactDetailSlots>({});

export function ContactDetailSlotsProvider({ value, children }: { value: ContactDetailSlots; children: ReactNode }) {
  return <ContactDetailSlotsContext.Provider value={value}>{children}</ContactDetailSlotsContext.Provider>;
}

export function useContactDetailSlots(): ContactDetailSlots {
  return useContext(ContactDetailSlotsContext);
}
